import { RangeValue } from 'types/Search/filter';

export const getRangeValue = (range: RangeValue<number> | undefined) =>
    [range?.min ?? null, range?.max ?? null].join(',');
